import { EDITOR_COLOR_SWATCHES } from "../components/Admin/newsletter-editor/utils/editorColorPalette";

/** Magazine accent greens and related tones for article body copy. */
export const ARTICLE_MAGAZINE_COLOR_SWATCHES = [
  "#5f8d7a",
  "#9fcbb9",
  "#4a7564",
  "#7aa892",
  "#cfe8dc",
  "#2f5245",
];

export const ARTICLE_EDITOR_COLOR_SWATCHES = [
  ...EDITOR_COLOR_SWATCHES,
  ...ARTICLE_MAGAZINE_COLOR_SWATCHES.filter((color) => !EDITOR_COLOR_SWATCHES.includes(color)),
];

export const ARTICLE_DEFAULT_FONT_SIZE = 17;

/** Figma px sizes used by article body typography (editor + public page). */
export const ARTICLE_FONT_SIZE_OPTIONS = [
  10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48,
];

export const ARTICLE_PARAGRAPH_ALIGN_OPTIONS = [
  { value: "left", label: "Sinistra" },
  { value: "center", label: "Centrato" },
  { value: "justify", label: "Giustificato" },
];
